.formField {
    color: var(--hps-blue);
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.5px;
    position: relative;
    margin: 0px;
}

.customFormControl{
    min-height: 35px;
    border: 1px solid #053c591a;
    opacity: 1;
    border-radius: 9px;
	color: #2D6E90;
    font-family: var(--hps-primary-font);
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.5px;
    line-height: 15px;
}

.labelAndBadgeContainer {
    display: flex;
}

.badge {
    display: flex;
    align-items: center;
    margin-left: 10px;
}

/* The rect date picker we use has a default of inline-block.
 * We need the input to be displayed as a block to show below the label and stretch full width.
 */
.datePickerOverride :global(.react-datepicker-wrapper),
.datePickerOverride :global(.react-datepicker-wrapper) input {
    display: block;
    width: 100%;
}

/* Matches the padding of Bootstrap's .form-control so the date picker's text aligns with other form fields. */
.datePickerOverride :global(.react-datepicker-wrapper) input {
    padding: 0.375rem 0.75rem;
}

.passwordToggleVisibilityButton {
    height: 1em;
    width: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
}